import { APP_TYPES } from "@config";
import { setActiveCombination } from "../loads/actions";
import { loadsTabModes } from "../loads/loadsTabModes";

export const SET_REBAR_DESIGN = 'SET_REBAR_DESIGN';
export const SET_EUROCODE_PLUS_FIRE_MINUTE = 'SET_EUROCODE_PLUS_FIRE_MINUTE';
export const SET_DESIGN = 'SET_DESIGN';
export const SET_DESIGN_TYPE = 'SET_DESIGN_TYPE';
export const SET_SAFETY_MINUTE = 'SET_SAFETY_MINUTE';
export const SET_SAFETY_FIRE_ATTACK = 'SET_SAFETY_FIRE_ATTACK';
export const SET_MAXIMUM_DEVIATION_ACTIVE = 'SET_MAXIMUM_DEVIATION_ACTIVE';
export const SET_MAXIMUM_DEVIATION_VALUE = 'SET_MAXIMUM_DEVIATION_VALUE';
export const SET_CHECK_PROFILE_RESISTANCE_ACTIVE = 'SET_CHECK_PROFILE_RESISTANCE_ACTIVE';

export const SET_DESIGN_FIXED_ANCHORAGE_DEPTH_SPECIFY = 'SET_DESIGN_FIXED_ANCHORAGE_DEPTH_SPECIFY';
export const SET_DESIGN_FIXED_ANCHORAGE_DEPTH_FIXED_ANCHORAGE_HEF = 'SET_DESIGN_FIXED_ANCHORAGE_DEPTH_FIXED_ANCHORAGE_HEF';
export const SET_DESIGN_EMBEDMENT_DEPTH_OPTION = 'SET_DESIGN_EMBEDMENT_DEPTH_OPTION';

export const SET_DESIGN_LOADS_DESIGN_VALUE = 'SET_DESIGN_LOADS_DESIGN_VALUE';
export const SET_DESIGN_LOADS_CHARACTERISTICS_VALUE = 'SET_DESIGN_LOADS_CHARACTERISTICS_VALUE';

export const SET_WORKING_LIFE_VALUE = 'SET_WORKING_LIFE_VALUE';

export const SET_CLADDING_COMBINATIONS = 'SET_CLADDING_COMBINATIONS';

export const SET_DESIGN_STATE = 'SET_DESIGN_STATE';
export const RESET_DESIGN_STATE = 'RESET_DESIGN_STATE';


/*
  Action creators
 */
export function resetDesignState() {
  return (dispatch) => {
    dispatch({ type: RESET_DESIGN_STATE });
    dispatch(updateDesignLoadCombinationValue());
  };
}
export function setDesignState(state) {
  return { type: SET_DESIGN_STATE, state };
}
export function setRebarDesign (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_REBAR_DESIGN, value, appType: APP_TYPES.REBAR_REINFORCEMENT });//getState().main.appType });
  };
}
export function setEurocodePlusFireMinute (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_EUROCODE_PLUS_FIRE_MINUTE, value, appType: APP_TYPES.REBAR_REINFORCEMENT });//getState().main.appType });
  };
}

export function setDesign (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN, value, appType: getState().main.appType });
  };
}
export function setDesignType (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_TYPE, value, appType: getState().main.appType });
  };
}
export function setSafetyMinute (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SAFETY_MINUTE, value, appType: getState().main.appType });
  };
}
export function setSafetyFireAttack (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SAFETY_FIRE_ATTACK, value, appType: getState().main.appType });
  };
}
export function setMaximumDeviationActive (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MAXIMUM_DEVIATION_ACTIVE, value, appType: getState().main.appType });
  };
}
export function setMaximumDeviationValue (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_MAXIMUM_DEVIATION_VALUE, value, appType: getState().main.appType });
  };
}
export function setCheckProfileResistanceActive (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CHECK_PROFILE_RESISTANCE_ACTIVE, value, appType: getState().main.appType });
    if (!value) {
      dispatch(setMaximumDeviationActive(false));
      dispatch(setMaximumDeviationValue(1/100));
    }
  };
}

export function setDesignFixedAnchorageDepthSpecify (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_FIXED_ANCHORAGE_DEPTH_SPECIFY, value, appType: getState().main.appType });
  };
}
export function setDesignFixedAnchorageDepthFixedAnchorageHef (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_FIXED_ANCHORAGE_DEPTH_FIXED_ANCHORAGE_HEF, value, appType: getState().main.appType });
  };
}
export function setDesignEmbedmentDepthOption (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_EMBEDMENT_DEPTH_OPTION, value, appType: getState().main.appType });
  };
}

export function setDesignLoadsDesignValue (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_LOADS_DESIGN_VALUE, value, appType: getState().main.appType });
  };
}
export function setDesignLoadsCharacteristicsValue (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DESIGN_LOADS_CHARACTERISTICS_VALUE, value, appType: getState().main.appType });
  };
}
export function updateDesignLoadCombinationValue() {
  return (dispatch, getState) => {
    if (getState().main.appType === APP_TYPES.GENERAL_CALCULATION) {
      var crtVal = getState().selectors.design[getState().main.appType].loads.design;
      var selectedCombinations = getState().selectors.loads[getState().main.appType].designLoadingData && 
        getState().selectors.loads[getState().main.appType].designLoadingData.filter(c => c.isSelected);
      if (!crtVal || 
        (crtVal === "Decisive" && selectedCombinations.length === 1) || 
        (crtVal !== "Decisive" && selectedCombinations.length > 1) || 
        !selectedCombinations.find(c => c.name === crtVal))
      {
        if (!selectedCombinations || selectedCombinations.length < 1 || selectedCombinations.length > 1)
          dispatch(setDesignLoadsDesignValue("Decisive"));
        else 
          dispatch(setDesignLoadsDesignValue(selectedCombinations[0].name));
      }
    }
  };
}
export function activateDesignCombination() {
  return (dispatch, getState) => {
    if (getState().main.appType === APP_TYPES.GENERAL_CALCULATION && 
        getState().selectors.loads[getState().main.appType].loadsTabMode === loadsTabModes.DESIGN) {
      let loadCombinations = getState().selectors.loads[getState().main.appType].designLoadingData;
      let designVal = getState().selectors.design[getState().main.appType].loads.design;
      let loadIdx = loadCombinations && designVal !== "Decisive" ? loadCombinations.findIndex(c => c.name === designVal) : -1;
      if (loadIdx >= 0) {
        dispatch(setActiveCombination(loadIdx));
      }
    }
  };
}

export function setWorkingLifeValue(value) {
  return (dispatch, getState) => {
    if (getState().main.appType === APP_TYPES.GENERAL_CALCULATION) 
    {
      dispatch({ type: SET_WORKING_LIFE_VALUE, value, appType: getState().main.appType });
    }
  };
}

export function setCladdingCombinations(firstOption, secondOption) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CLADDING_COMBINATIONS, firstOption, secondOption, appType: getState().main.appType });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/design/actions.js